export const ORG_PERMISSION_LABELS = [
  'ORGANIZATION_NAME', 'ORGANIZATION_NAME_FR', 'SECONDARY_NAME', 'SECONDARY_NAME_FR',
  'ORGANIZATION_LOGO', 'ORGANIZATION_TYPE', 'ORGANIZATION_SUBTYPE', 'PARENT_ORGANIZATION',
  'FOUNDING_DATE_OF_ORGANIZATION', 'YEAR_OF_WOSM_MEMBERSHIP', 'WOSM_MEMBERSHIP_HISTORY',
  'COUNTRY_TERRITORY_NAME', 'COUNTRY_TERRITORY_NATIONAL_FLAG', 'REGION_ORG', 'ORGANIZATION_ACRONYM',
  'ABBREVIATION_UNIQUE_ACRONYM', 'NSO_SETUP', 'POTENTIAL_MEMBER_ORGANIZATION', 'MEMBER_OF_WAGGGS',
  'WAGGGS_SPECIAL_STATUS_NOTE', 'SUSPENSION_STATUS', 'ORGANIZATION_ORDER', 'ORGANIZATION_PREFERRED_GLOBAL_LANGUAGE',
  'ORGANIZATION_PREFERRED_WORKING_LANGUAGE', 'ORGANIZATION_CURRENCY', 'NOTES', 'UPCOMING_EVENTS', 'HOSTED_PAST_WOSM_EVENTS',
  'KEY_SUMMARY_OF_NSO', 'VISIBLE_IN_DIRECTORY', 'CONTACTS_ORGANIZATION', 'APPOINTEES', 'DELETE_ORGANIZATION',
  'ORGANIZATION_EVENT_CATEGORY', 'ORGANIZATION_FEE_CATEGORY', 'ORGANIZATION_SUSPENSION_INFORMATION',
  'ORGANIZATION_CONFIDENTIAL_INFORMATION', 'ORGANIZATION_SUMMARY_NOTE', 'ORGANIZATION_CONSTITUTION_YEAR',
  'ORGANIZATION_CONSTITUTION_RECEIVED', 'ORGANIZATION_POLICY_INFORMATION', 'ORGANIZATION_INTERACTIONS',
  'ORGANIZATION_SAFE_FROM_HARM_REPORTING',
  'ORGANIZATION_SAFE_FROM_HARM_POLICY', 'ORGANIZATION_SAFE_FROM_HARM_ASSESSMENT'
];


//   'WSD_IDM_PROFILE',
export const PERSON_PERMISSION_LABELS = [
  'TITLE', 'FIRST_NAME', 'INITIALS', 'MIDDLE_NAME', 'LAST_NAME', 'SUFFIX',
  'HONOURS', 'PROFILE_IMAGE', 'GENDER', 'ORGANIZATION', 'COUNTRY_TERRITORY', 'REGION_PERSON',
  'SCOUT_ORG_USER_E_MAIL', 'SCOUT_ORG_USER_LANGUAGE', 'SCOUT_ORG_USER_LANGUAGES_I_KNOW', 'ROLES',
  'APPOINTMENTS_INCL_DIRECTORY_TITLES', 'PORTFOLIO_AREAS_OF_EXPERTISE', 'COMMENT', 'CONTACTS_PERSON',
  'VOLUNTEER_BUSINESS_CARD'
];

export const NDP_PERMISSION_LABELS = [
  'NDP_ORGANIZATION_CONTACT_DATA',
  'NDP_ORGANIZATION_INTERACTION_CONFIDENTIAL',
  'NDP_ORGANIZATION_SUSPENSION_INFORMATION',
  'NDP_ORGANIZATION_SUSPENSION_INFORMATION_CONFIDENTIAL',
  'NDP_ORGANIZATION_PROJECTS_WIDGET',
  'NDP_ORGANIZATION_GSAT',
  'NDP_ORGANIZATION_CONSTITUTION',
  'NDP_ORGANIZATION_ANNUAL_REPORT',
  'NDP_ORGANIZATION_COMPLIANCY',
  'NDP_ORGANIZATION_INTERACTION',
  'NDP_ORGANIZATION_GOOD_STANDING_STATUS',
  'NDP_ORGANIZATION_PROJECTS_MOP',
  'NDP_ORGANIZATION_POLICY_DOCUMENTS',
  'NDP_ORGANIZATION_SUMMARY_NOTES',
  'NDP_ORGANIZATION_FINANCIAL_REPORT',
  'NDP_ORGANIZATION_FEE_CATEGORY',
  'NDP_ORGANIZATION_CENSUS_PERIOD',
  'NDP_ORGANIZATION_BENEFICIARY_CATEGORY',
  'NDP_ORGANIZATION_AGE_GROUP',
  'NDP_ORGANIZATION_CUSTOM_AGE_GROUP',
  'NDP_ORGANIZATION_SHADOW_CENSUS',
  'NDP_ORGANIZATION_HISTORICAL_CENSUS',
  'NDP_ORGANIZATION_SFH',
  'NDP_FEDERATION',
  'NDP_REGION',
  'NDP_WORLD',
  'NDP_EXPORT',
  'NDP_CUSTOM_WIDGETS'
];

export const NDP_READ_ONLY_PERMISSIONS = [
  'NDP_EXPORT',
  'NDP_ORGANIZATION_CONTACT_DATA',
  'NDP_ORGANIZATION_INTERACTION_CONFIDENTIAL',
  'NDP_ORGANIZATION_INTERACTION',
  'NDP_ORGANIZATION_SUSPENSION_INFORMATION',
  'NDP_ORGANIZATION_SUSPENSION_INFORMATION_CONFIDENTIAL',
  'NDP_ORGANIZATION_PROJECTS_WIDGET',
  'NDP_ORGANIZATION_COMPLIANCY',
  'NDP_ORGANIZATION_SUMMARY_NOTES',
  'NDP_ORGANIZATION_GSAT',
  'NDP_ORGANIZATION_CONSTITUTION',
  'NDP_ORGANIZATION_ANNUAL_REPORT',
  'NDP_ORGANIZATION_GOOD_STANDING_STATUS',
  'NDP_ORGANIZATION_PROJECTS_MOP',
  'NDP_ORGANIZATION_POLICY_DOCUMENTS',
  'NDP_FEDERATION',
  'NDP_ORGANIZATION_SFH',
  'NDP_ORGANIZATION_FINANCIAL_REPORT',
  'NDP_ORGANIZATION_FEE_CATEGORY'
];

export const NDP_UPDATE_ONLY_PERMISSIONS = ['NDP_ORGANIZATION_HISTORICAL_CENSUS'];

export const NDP_NOT_CREATE_PERMISSIONS = ['NDP_ORGANIZATION_SHADOW_CENSUS'];

export const NDP_NOT_DELETE_PERMISSIONS = [
  'NDP_ORGANIZATION_SHADOW_CENSUS',
  'NDP_ORGANIZATION_CENSUS_PERIOD',
  'NDP_ORGANIZATION_AGE_GROUP'];

export const ADMINISTRATION_LABELS = [
  'WSD_CLASSIFICATIONS',
  'WSD_NOTIFICATIONS',
  'WSD_USER_ROLES',
  'WSD_PERSON',
  'WSD_ORGANIZATION',
  'WSD_TRACK_CHANGES',
  'WSD_IDM_USER_REPORT',
];

export const READ_ONLY_ADMINISTRATION_LABELS = [
  'WSD_TRACK_CHANGES',
  'WSD_IDM_USER_REPORT',
];
